/**
 * Centralized API configuration utility
 * Handles baseURL and path construction to avoid duplicate /api/v1 issues
 */
import axios from 'axios';

/**
 * Get the correct base URL for API requests
 * In development: use empty string to let proxy handle routing
 * In production: use full URL with /api/v1
 */
export const getApiBaseUrl = () => {
  // Don't set baseURL here since axios.defaults.baseURL is already set in index.js
  return '';
};

/**
 * Get the correct API path
 * In development: include /api/v1 prefix since baseURL is empty
 * In production: exclude /api/v1 prefix since it's in baseURL
 */
export const getApiPath = (path) => {
  return path; // Always return path as-is since baseURL includes /api/v1
};

/**
 * Create axios instance with correct configuration  
 * Use axios defaults since baseURL is already set in index.js
 */
export const createApiInstance = (additionalConfig = {}) => {
  return axios.create({
    timeout: 10000,
    ...additionalConfig
  });
};

/**
 * Portal-specific API configuration
 */
export const portalApiConfig = {
  getBaseUrl: getApiBaseUrl,
  getPath: getApiPath,
  
  // Common portal endpoints
  endpoints: {
    login: '/portal/login',
    healthOverview: '/portal/health-overview',
    timeline: '/portal/timeline',
    problems: '/portal/problems',
    medications: '/portal/medications',
    education: '/portal/education',
    changePassword: '/portal/change-password'
  }
};